import { render } from "./ForgetPassword.vue?vue&type=template&id=257f1e80&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=257f1e80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-257f1e80"

export default script